import axios from "axios";
import Config from "../managers/ConfigManager";
import TokenManager from "../managers/TokenManager";
import AlertManager from "../managers/AlertManager";

export default {
  request: function() {
    const headers = {
      "Content-Type": "application/json",
      "x-api-key": Config.getApiKey(),
      "x-client-info": "dah-sale-" + Config.getVersion(),
      "x-language": "en"
    };
    // Set config defaults when creating the instance
    const instance = axios.create({
      baseURL: Config.getBaseURL(),
      headers: headers
    });
    let token = TokenManager.getAdfsToken();
    if (token !== "") {
      // Alter defaults after instance has been created
      instance.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    return instance;
  },
  requestGeoSearch: function() {
    const instance = axios.create({
      baseURL: "https://geosearch.cdg.co.th/g/search"
    });
    return instance;
  },
  errorMessage: function(error) {
    switch (error.response.status) {
      case 401:
        AlertManager.showClientErrorAlertDialog(
          error.response.status,
          "Unauthorized! Please login again",
          this.navigateToLoginPage
        );
        break;

      case 403:
        AlertManager.showClientErrorAlertDialog(
          error.response.status,
          "Permission Denied! Please contact system administrator",
          this.navigateToHomePage
        );
        break;

      default:
        AlertManager.showTechnicalErrorAlertDialog(error.response.status);
    }
    return error.response;
  },
  navigateToLoginPage: function() {
    localStorage.clear();
    location.href = process.env.BASE_URL + "login";
  },
  navigateToHomePage: function() {
    location.href = process.env.BASE_URL;
  }
};
